import React from 'react'
import Header from '../Header'
import Artsbanner from '../arts/Artsbanner'
import Footer from '../Footer'
import Career from './Career'
import AcademicsPage from './AcademicsPage'
import Artssubject from './Artssubject'

const Academics = () => {
  return (
    <div>
      <Header/>
      <Artsbanner/>
      <AcademicsPage/>
      <Artssubject/>
      <Career/>
      <Footer/>
    </div>
  )
}

export default Academics